export default __webpack_public_path__ + "static/media/hotgig-app-logo.bd44bf94.png";